import { render } from "./logisticsMent.vue?vue&type=template&id=4857ca32&scoped=true"
import script from "./logisticsMent.vue?vue&type=script&lang=js"
export * from "./logisticsMent.vue?vue&type=script&lang=js"

import "./logisticsMent.vue?vue&type=style&index=0&id=4857ca32&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4857ca32"]])

export default __exports__